const houseMaidService = {
  title: "House Maid",
  icon: "🧹",
  rateCardKey: "house-maid",
  shortDescription:
    "Dusting, sweeping, mopping, utensil cleaning, and recurring home support.",
  longDescription:
    "Book one-time or recurring household help for basic cleaning, utensils, and regular home upkeep support. Monthly pricing depends on duration, work scope, and city.",
  consultationNote:
    "Long-term monthly maid placement, live-in staffing, or multi-task bundled support should begin with requirement confirmation.",
  responsePromise:
    "Assignment depends on time slot, locality, recurring schedule, and helper availability.",
  warrantyPolicy:
    "Service quality depends on daily scope clarity, home size, and attendance consistency.",
  subServices: [
    {
      id: "maid-basic-cleaning",
      title: "Dusting + Sweeping + Mopping",
      icon: "🧽",
      group: "Recurring Support",
      description:
        "Basic recurring cleaning support for common home maintenance tasks.",
      basePrice: 1499,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
    {
      id: "maid-utensil-cleaning",
      title: "Utensil Cleaning Support",
      icon: "🍽️",
      group: "Recurring Support",
      description:
        "Daily utensil washing support based on household volume and timing.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
    {
      id: "maid-one-time-basic",
      title: "One-time Maid Visit",
      icon: "🪣",
      group: "One-time",
      description:
        "One-time household cleaning support for basic dusting, sweeping, and mopping.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "Visit completion only",
      unit: "visit",
    },
    {
      id: "maid-bundled-home-support",
      title: "Cleaning + Utensils Bundle",
      icon: "🏠",
      group: "Recurring Support",
      description:
        "Recurring bundled support for cleaning and utensil work together.",
      basePrice: 2499,
      priceType: "starts_at",
      duration: "Monthly plan",
      warranty: "Attendance/support policy",
      unit: "month",
    },
  ],
};

export default houseMaidService;